import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import enTranslation from './locales/en';
import deTranslation from './locales/de';

i18n.use(initReactI18next).init({
  resources: {
    en: enTranslation,
    de: deTranslation,
  },
  lng: 'en',
  fallbackLng: 'en',
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
